import { render, staticRenderFns } from "./DashWeekChart.vue?vue&type=template&id=8a83f130&scoped=true"
import script from "./DashWeekChart.vue?vue&type=script&lang=js"
export * from "./DashWeekChart.vue?vue&type=script&lang=js"
import style0 from "./DashWeekChart.vue?vue&type=style&index=0&id=8a83f130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83f130",
  null
  
)

export default component.exports